import {
  GET_FORM_JSON,
  CLEAR_FORM,
  UPDATE_FORM
} from '../constants/action-types';

// INITIALIZE STATE
const initialState = {
  form: {
    Name: "Untitled Form"
  }
};

// REDUCER
export const FormReducer = (state = initialState, action) => {
  const form = action.payload

  switch (action.type) {
    case GET_FORM_JSON: {
        return {
            ...state,
            form
        }
    }
    case UPDATE_FORM: {
      return {
          ...state,
          form: JSON.parse(action.payload)
      }
    }
    case CLEAR_FORM: {
      return {
          ...state,
          form: {},
      }
  }

    default:
        return state;
  }
};